import React from 'react';
import { Button, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus,
  faDollarSign,
  faPrint,
  faSave,
  faFileAlt,
} from '@fortawesome/free-solid-svg-icons';

/** The one mode-specific button, keyed by MODES[mode].action. */
const ACTION_BUTTONS = {
  save: { label: 'Save', icon: faSave, form: true },
  update: { label: 'Edit', icon: faSave, form: true },
  addToGl: { label: 'Add GL', icon: faFileAlt },
  editMutation: { label: 'Edit Mutation Date', width: '160px' },
  liquid: { label: 'Liquid', icon: faDollarSign },
};

const Content = ({ busy, icon, label }) => {
  if (busy) return <Spinner size="sm" color="white" />;
  return (
    <span>
      {icon && <FontAwesomeIcon icon={icon} className="mr-1" />} {label}
    </span>
  );
};

/** New / <mode action> / Print strip in the card's top-right corner. */
const DetailActions = ({ mode, hasId, busy, onNew, onAction, onPrint }) => {
  const action = ACTION_BUTTONS[mode.action];
  return (
    <div
      className="d-flex flex-row-reverse"
      style={{ marginTop: '-39px', right: '0%', position: 'absolute' }}
    >
      <Button
        className="btn-add-pym ml-1"
        color="success"
        size="md"
        style={{ backgroundColor: '#32b280', width: '100px' }}
        onClick={onNew}
      >
        <FontAwesomeIcon icon={faPlus} className="mr-1" /> New
      </Button>
      {action && (
        <Button
          className={action.form ? 'btn-add-pym' : undefined}
          color={action.form ? 'secondary' : undefined}
          size={action.form ? 'md' : undefined}
          style={{ width: action.width || '100px' }}
          onClick={onAction}
        >
          <Content
            busy={busy === mode.action}
            icon={action.icon}
            label={action.label}
          />
        </Button>
      )}
      {hasId && (
        <Button
          color="primary"
          className="btn-add-pym mr-1"
          style={{ width: '100px' }}
          onClick={onPrint}
        >
          <Content busy={busy === 'print'} icon={faPrint} label="Print" />
        </Button>
      )}
    </div>
  );
};

export default DetailActions;
